module.exports = __webpack_public_path__ + "static/img/guide-23.77f827b6.png";